import { Gender, VaeSurveillanceType } from "@/models";

export function displayGender(value?: Gender) {
  switch (value) {
    case Gender.Female:
      return "Female";
    case Gender.Male:
      return "Male";
    default:
      return "Unknown";
  }
}

export function displayVaeSurveillanceType(value?: VaeSurveillanceType) {
  switch (value) {
    case VaeSurveillanceType.CriteriaMet:
      return "VAE Met";
    case VaeSurveillanceType.VaeDay1:
      return "VAE 1d";
    case VaeSurveillanceType.VaeDay2:
        return "VAE 2d";
    default:
      return "None";
  }
}